import classnames from 'classnames/bind';
import styles from './checkboxFilterLabel.module.scss';

const cx = classnames.bind(styles);

type CheckboxFilterLabelProps = {
    showAggregation: boolean;
    aggregationText: string;
    description: string;
};

export const CheckboxFilterLabel = ({ showAggregation, aggregationText, description }: CheckboxFilterLabelProps) => (
    <span className={styles.label} data-testid="checkbox-label"> 
        {description} {showAggregation ? <span className={cx(styles.aggregation)} data-testid="checkbox-aggregation-number">{aggregationText}</span> : '' }
        
    </span>
);
